import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { loadFonts } from '../../actions/theme';
import HeadingsAndButtons from './in-context/components/HeadingsAndButtons';
import NavBar from './in-context/components/NavBar'
import CardComponent from './in-context/components/CardComponent'
import FormElements from './in-context/components/FormElements'
import Calendar from './in-context/components/Calendar'
import UrgencyBadges from "./in-context/components/UrgencyBadges";
import MessagesGrid from "./in-context/components/MessagesGrid";
import Filters from './in-context/components/Filters';


class InContextTheme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopoverOpen: false,
            keepPopoverOpen: false
        };
        this.popoverRef = null;
    }

    componentDidMount() {
        const { chainId, hotelId, level } = this.props;
        this.props.loadFonts(chainId, hotelId, level);
        // Add click outside listener
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.level !== nextProps.level ||
            this.props.chainId !== nextProps.chainId ||
            this.props.hotelId !== nextProps.hotelId
        ) {
            nextProps.loadFonts(nextProps.chainId, nextProps.hotelId, nextProps.level);
        }
    }

    handleClickOutside = (event) => {
        // Only close if popover is open, we have a ref, click is outside, and keepPopoverOpen is false
        // Also make sure we're not clicking on the toggle button
        const isClickOnButton = event.target.closest('button');
        if (this.state.isPopoverOpen &&
            this.popoverRef &&
            !this.popoverRef.contains(event.target) &&
            !this.state.keepPopoverOpen &&
            !isClickOnButton) {
            this.setState({ isPopoverOpen: false });
        }
    }

    setPopoverRef = (element) => {
        this.popoverRef = element;
    }

    togglePopover = (event) => {
        if (event) {
            event.preventDefault();
        }
        this.setState(prevState => ({
            isPopoverOpen: !prevState.isPopoverOpen,
            keepPopoverOpen: false // Reset keepPopoverOpen when toggling
        }));
    }

    handleKeepOpenChange = (event) => {
        this.setState({ keepPopoverOpen: event.target.checked });
    }

    getThemeStyles() {
        const { inContextTheme } = this.props;
        const styles = {};

        // Convert Redux state to CSS custom properties
        Object.keys(inContextTheme).forEach(colorKey => {
            styles[`--${colorKey}`] = inContextTheme[colorKey];
        });
        return styles;
    }
    render() {
        const themeStyles = this.getThemeStyles();
        const { isPopoverOpen, keepPopoverOpen } = this.state;

        return (
            <div className="InContextTheme" style={themeStyles}>
                <div className="ThemeColors Theme-Content" style={{ fontFamily: "var(--font-body) !important" }}>
                    <HeadingsAndButtons />
                    <NavBar />
                    <Filters />
                    <h3 style={{ fontFamily: "var(--font-titles)", color: 'var(--foreground, #000)', fontWeight: 'bold' }}>Card</h3>
                    <div className="row card-and-calendar">
                        <div className="col-md-6 pl-0">
                            <CardComponent />
                        </div>
                        <div className="col-md-6">
                            <FormElements />
                        </div>
                    </div>
                    <h3 style={{ fontFamily: "var(--font-titles)", color: 'var(--foreground, #000)', fontWeight: 'bold' }}>Popover</h3>
                    <div style={{ position: 'relative', marginBottom: '20px' }}>
                        <button className='calendar-popover-button focusable-element' onClick={this.togglePopover}>
                            {isPopoverOpen ? 'Close calendar popover' : 'Open calendar popover'}
                        </button>
                        {isPopoverOpen && (
                            <div ref={this.setPopoverRef} className='calendar-popover'>
                                <div className='calendar-popover-header'>
                                    <label htmlFor="keepOpenCheck" className='calendar-popover-label'>
                                        <input className='calendar-popover-checkbox'
                                            type="checkbox"
                                            id="keepOpenCheck"
                                            checked={keepPopoverOpen}
                                            onChange={this.handleKeepOpenChange}
                                        />
                                        Keep popover open
                                    </label>
                                    <span className="spark-icon-close spark-icon--sm" onClick={this.togglePopover}></span>
                                </div>
                                <Calendar themeStyles={this.getThemeStyles()} />
                            </div>
                        )}
                    </div>
                    <h3 style={{ fontFamily: "var(--font-titles)", color: 'var(--foreground, #000)', fontWeight: 'bold' }}>Alerts</h3>
                    <UrgencyBadges />
                    <MessagesGrid />
                </div>
            </div>
        );
    }
}

InContextTheme.propTypes = {
    children: PropTypes.element,
    loadFonts: PropTypes.func
};

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        inContextTheme: state.app.data.inContextTheme.light || {}
    };
};

const mapDispatchToProps = dispatch => ({
    loadFonts: (chainId, hotelId, level) => dispatch(loadFonts({ chainId, hotelId, level }))
});

export default connect(mapStateToProps, mapDispatchToProps)(InContextTheme);



// WEBPACK FOOTER //
// ./src/components/pages/InContextTheme.js